var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiringList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.9988L9 13.0012L13 8.99649M19 10.9988C19 15.9752 14.9706 20.0094 10 20.0094C5.02944 20.0094 1 15.9752 1 10.9988C1 6.02244 5.02944 1.98828 10 1.98828C14.9706 1.98828 19 6.02244 19 10.9988Z",
    stroke: "#004AF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringList);
export default __webpack_public_path__ + "static/media/hiring_list.0d0d9f6920731ebe93943ee4157e5e42.svg";
export { ForwardRef as ReactComponent };